/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlSeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceControlSeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceControlSeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlSeverityQueryOperator>): ComplianceControlSeverityQueryOperator {
        let obj = Object.assign(new ComplianceControlSeverityQueryOperator(), model);
        ComplianceControlSeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlSeverityQueryOperator>): ComplianceControlSeverityQueryOperator {
        if (!model) return null;
        return ComplianceControlSeverityQueryOperator.newInstance(<ComplianceControlSeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlSeverityQueryOperator) {
        if (!obj) return;

        models.ComplianceControlSeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlSeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlSeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Severities to include
     */
    severities: Array<models.Severity>;

}
